import React from 'react';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { ReferralStrategyForEdit, ReferralStrategyVariant } from '../../types';
import { FEATURE_FLAG_KEYS } from '../../../../../../../../config/growthbook';
import SingleReferralStrategyDropdown from './SingleReferralStrategyDropdown';
import CategoryReferralStrategyDropdown from './CategoryReferralStrategyDropdown';

type SingleItemProps = {
  variant: ReferralStrategyVariant.SINGLE;
  value: ReferralStrategyForEdit | null | undefined;
  onChange: (strategy: ReferralStrategyForEdit) => void;
};

type CategoryCoverageProps = {
  variant: ReferralStrategyVariant.CATEGORY_COVERAGE;
  keys: string[];
};

type CategoryRatingOptionProps = {
  variant: ReferralStrategyVariant.CATEGORY_RATING_OPTION;
  keys: string[];
};

type ReferralStrategyDropdownProps =
  | SingleItemProps
  | CategoryCoverageProps
  | CategoryRatingOptionProps;

function ReferralStrategyDropdown(props: ReferralStrategyDropdownProps) {
  const isShowReferralStrategyOn = useFeatureIsOn(
    FEATURE_FLAG_KEYS.SHOW_REFERRAL_STRATEGY
  );

  if (!isShowReferralStrategyOn) {
    return null;
  }

  if (props.variant === ReferralStrategyVariant.SINGLE) {
    const singleProps = props as SingleItemProps;
    return (
      <SingleReferralStrategyDropdown
        value={singleProps.value}
        onChange={singleProps.onChange}
      />
    );
  }

  const categoryProps = props as
    | CategoryCoverageProps
    | CategoryRatingOptionProps;
  return (
    <CategoryReferralStrategyDropdown
      variant={categoryProps.variant}
      keys={categoryProps.keys}
    />
  );
}

export default ReferralStrategyDropdown;
